const styles = () => {
  return {
    dropUploader: {
      background: "#FFFFFF",
      border: "1px dashed #959CB6",
      //   boxSizing: "border-box",
      height: "86px",
      borderRadius: "4px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      marginBottom: "8px",
      "&:focus": {
        outline: "none",
      },
    },
    uploadIcon: {
      marginRight: "12px",
      //   textAlign: "center",
      width: "47px",
      display: "inherit",
      background: "#F7F8FA",
      borderRight: "1px dashed #959CB6",
      display: "flex",
      height: "84px",
      //   display: "-webkit-flex" /* Safari */,
      //   display: "flex",
      alignItems: "center",
      "-webkit-align-items": "center" /* Safari 7.0+ */,
      "-webkit-justify-content": "center",
      justifyContent: "center",
    },
    contentText: {
      width: "180px",
      //   display: "inherit",
      verticalAlign: "middle",
      color: "#808080",
      fontSize: "14px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      //   display: "-webkit-flex" /* Safari */,
      //   display: "flex",
      alignItems: "center",
      "-webkit-align-items": "center" /* Safari 7.0+ */,
      "-webkit-justify-content": "center",
      justifyContent: "center",
    },
    crossIcon: {
      paddingRight: "14px",
      //   float: "right",
      //   display: "-webkit-flex" /* Safari */,
      //   display: "flex",
      alignItems: "center",
      "-webkit-align-items": "center" /* Safari 7.0+ */,
      "-webkit-justify-content": "center",
      justifyContent: "center",
    },
    uploaderText: {
      color: "#18AF8B",
    },
    error: {
      border: "1px solid #FF0000",
    },
    metaInfo: {
      fontSize: "11px",
      color: "#808080",
      marginTop: "8px",
    },
    fileDetails: {
      marginTop: "5px",
    },
    fileName: {
      color: "#808080",
      wordBreak: "break-all",
      fontSize: "12px",
    },
    fileError: {
      fontSize: "9px",
      color: "#FF0000",
    },
    selectFileText: {
      borderBottom: "1px #f8bf45 solid",
    },
  };
};

export default styles;
